export const START_FETCH_SEDI_PAGE_DATA = "START_FETCH_SEDI_PAGE_DATA";
export const SUCCESS_FETCH_SEDI_PAGE_DATA = "SUCCESS_FETCH_SEDI_PAGE_DATA";
export const ERROR_FETCH_SEDI_PAGE_DATA = "ERROR_FETCH_SEDI_PAGE_DATA";

export const START_FETCH_SEDI_DETAIL = "START_FETCH_SEDI_DETAIL";
export const SUCCESS_FETCH_SEDI_DETAIL = "SUCCESS_FETCH_SEDI_DETAIL";
export const ERROR_FETCH_SEDI_DETAIL = "ERROR_FETCH_SEDI_DETAIL";
export const EMPTY_FETCH_SEDI_DETAIL = "EMPTY_FETCH_SEDI_DETAIL";
